(function () {
  "use strict";
  if (window.__flxVielfaltInit) return;
  window.__flxVielfaltInit = true;

  function init() {
    var grid = document.querySelector("[data-flx-vielfalt-grid]");
    if (!grid) return;
    var poolScript = grid.parentElement.querySelector("[data-flx-vg-pool]") || document.querySelector("[data-flx-vg-pool]");
    if (!poolScript) return;

    var pool = [];
    try {
      pool = JSON.parse(poolScript.textContent || "[]");
    } catch (e) {
      return;
    }
    // Nur Produkte mit echtem Bild verwenden
    pool = pool.filter(function (p) { return p && p.image; });
    if (pool.length < 2) return;

    var tiles = Array.prototype.slice.call(grid.querySelectorAll("[data-flx-vg-tile]"));
    if (!tiles.length) return;

    function pickRandom(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
      }
      return a;
    }

    // Aktuell auf den Kacheln sichtbare Produkt-IDs (verhindert Duplikate)
    var shown = {};

    function setTile(tile, product, animate) {
      var img = tile.querySelector("img");
      if (!img) {
        img = document.createElement("img");
        img.loading = "lazy";
        img.width = 400;
        img.height = 400;
        var inner = tile.querySelector(".flx-vg__inner");
        if (inner) inner.appendChild(img);
      }
      function apply() {
        img.src = product.image;
        img.alt = product.title || "";
        tile.href = product.url || tile.href;
        tile.setAttribute("data-flx-vg-pid", product.id);
        if (animate) {
          // kurz warten, dann einblenden
          requestAnimationFrame(function () {
            img.classList.remove("flx-vg-fading");
          });
        }
      }
      if (animate && img.src) {
        img.classList.add("flx-vg-fading");
        setTimeout(apply, 350);
      } else {
        apply();
      }
    }

    // Initiale Zufalls-Belegung: 10 verschiedene Produkte aus dem Pool
    var initial = shuffle(pool).slice(0, tiles.length);
    tiles.forEach(function (tile, i) {
      var product = initial[i] || pickRandom(pool);
      shown[product.id] = true;
      setTile(tile, product, false);
    });

    // Alle ~1s: eine zufaellige Kachel auf ein neues, aktuell nirgends
    // angezeigtes Produkt umschalten.
    function tick() {
      if (document.hidden) return; // Tab im Hintergrund: keine unnoetige Arbeit
      var tile = pickRandom(tiles);
      var currentId = tile.getAttribute("data-flx-vg-pid");
      var candidates = pool.filter(function (p) {
        return String(p.id) !== String(currentId) && !shown[p.id];
      });
      if (!candidates.length) return; // alle Produkte gerade sichtbar - ueberspringen
      var next = pickRandom(candidates);
      if (currentId && shown.hasOwnProperty(currentId)) delete shown[currentId];
      shown[next.id] = true;
      setTile(tile, next, true);
    }

    // Philip: 1-1.5s Standzeit je Wechsel, 1s wirkte insgesamt zu hektisch.
    setInterval(tick, 1300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
